<template>
    <div class="page-container" :class="{ collapsed: !$store.getters.sidebarOpened }">
        <div class="area-container left-area">
            <CommonTree
                ref="faculty_tree"
                type="room"
                :showFilter="true"
                @change="handleNodeClick"
                :customStyle="{ height: 'calc(100vh - 158px)', borderRight: 'none', width: '100%' }"
            />
        </div>
        <div class="data-container center-area">
            <div class="tool-box">
                <el-button type="primary" :icon="Refresh" @click="resetQueryForm">刷新</el-button>
                <el-button type="primary" :icon="Plus" plain @click="onAddClick()" v-permission="['heating:device-manage:add']">
                    添加
                </el-button>
                <el-button
                    type="primary"
                    :icon="Upload"
                    plain
                    @click="onRemoveClick(selected_ids)"
                    v-permission="['heating:device-manage:remove']"
                >
                    批量删除
                </el-button>
                <el-button @click="uploadVisible = true" :icon="Download" v-permission="['heating:device-manage:import']">
                    导入
                </el-button>
                <el-button @click="handleExport" :icon="Upload" v-permission="['heating:device-manage:export']">导出</el-button>
            </div>
            <el-form class="search-form" ref="search_form" :inline="true" :model="search_params" label-position="top">
                <el-form-item label="户名" prop="name">
                    <el-input style="width: 165px" v-model="search_params.name" clearable placeholder="请输入名称" />
                </el-form-item>
                <el-form-item label="状态" prop="online">
                    <el-select v-model="search_params.online" placeholder="请选择状态" style="width: 165px" clearable>
                        <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="Number(item.value)"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="IMEI" prop="IMEI">
                    <el-input style="width: 165px" placeholder="请输入IMEI" v-model="search_params.IMEI" clearable />
                </el-form-item>
                <el-form-item label="ICCID" prop="ICCID">
                    <el-input style="width: 165px" placeholder="请输入ICCID" v-model="search_params.ICCID" clearable />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :icon="Search" plain @click="getTableData">搜索</el-button>
                    <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table
                class="data-table"
                :data="table_data"
                v-loading="tableLoading"
                @selection-change="handleSelectionChange"
                scrollbar-always-on
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column label="户名" fixed="left" prop="name" width="130px" show-overflow-tooltip></el-table-column>
                <el-table-column label="设备类型 / 型号" width="150px" prop="device_type">
                    <template #default="{ row }">
                        <span v-if="row.model === null"></span>
                        <span v-else-if="model_list[row.model]">
                            {{ row.model ? model_list[row.model].type + '/' + model_list[row.model].model : '' }}
                        </span>
                        <span v-else>设备型号不存在</span>
                    </template>
                </el-table-column>
                <el-table-column label="IMEI" width="150px" prop="IMEI"></el-table-column>
                <el-table-column label="安装位置" min-width="250px" prop="location" show-overflow-tooltip>
                    <template #default="{ row }">
                        <span v-show="row.room">{{ room_list[row.room] }}</span>
                        <span v-show="row.location">/{{ row.location }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" width="90" prop="online" align="center">
                    <template #default="{ row }">
                        <span v-if="row.online" style="color: #67c23a">在线</span>
                        <span v-else style="color: #f56c6c">离线</span>
                    </template>
                </el-table-column>
                <el-table-column label="首次注册时间" width="160px" prop="reg_ts"></el-table-column>
                <el-table-column label="版本号" width="100px" prop="version"></el-table-column>
                <el-table-column label="ICCID" width="200px" prop="ICCID"></el-table-column>
                <el-table-column label="联系电话" width="160px" prop="phone"></el-table-column>
                <el-table-column label="操作" fixed="right" width="220">
                    <template #default="{ row }">
                        <el-button
                            type="primary"
                            link
                            :icon="View"
                            v-permission="['heating:device-manage:detail']"
                            @click="onShowClick(row)"
                        >
                            详情
                        </el-button>
                        <el-button
                            type="primary"
                            link
                            :icon="Edit"
                            @click="onEditClick(row)"
                            v-permission="['heating:device-manage:edit']"
                        >
                            编辑
                        </el-button>
                        <el-button
                            type="primary"
                            :icon="Delete"
                            link
                            @click="onRemoveClick([row.id])"
                            v-permission="['heating:device-manage:remove']"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination
                v-if="table_data.length > 0"
                :current-page="page_params.page"
                :page-size="page_params.page_size"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            />
            <forms-dialog
                v-if="formDialogVisible"
                v-model="formDialogVisible"
                :isForm="isForm"
                :modelId="selectModelId"
                :detailData="detail_data"
                @updateForm="getTableData"
            />
            <imports-form
                v-if="uploadVisible"
                v-model="uploadVisible"
                @updateForm="importsComplete"
                menuCode="heating/device/data"
                :params-data="{ type: 1 }"
            />
        </div>
    </div>
</template>

<script setup>
import { onMounted, reactive, ref, watch } from 'vue'
import { Delete, Download, Edit, Plus, Refresh, Search, Upload, View } from '@element-plus/icons'
import { addIMEI, batchDeleteDevice, getDeviceList } from '@/api/heating/devicePoint/devicePoint.js'
import FormsDialog from './components/forms.vue'
import { ElLoading, ElMessage, ElMessageBox } from 'element-plus'
import ImportsForm from '@/components/ImportsForm.vue'
import Pagination from '@/components/Pagination/index.vue'
import CommonTree from '@/components/BuildTree/CommonTree.vue'
import { getOptionTree } from '@/api/room.js'
import { getEquipModelTree } from '@/api/equipment.js'
import Exceljs from 'exceljs'
import FileSaver from 'file-saver'

// 型号列表
const model_list = ref({})
async function getModelList() {
    await getEquipModelTree().then((data) => {
        const list = {}
        data.forEach((device_type) => {
            device_type?.children &&
                device_type.children.forEach((device_model) => {
                    list[device_model.id] = {
                        type: device_type.name,
                        model: device_model.name
                    }
                })
        })
        model_list.value = list
    })
}

// 安装位置
const room_list = ref({})
async function getRoomTree() {
    const room_locations = {}
    function getRoom(list, location) {
        list.forEach((item) => {
            if (item.children) {
                getRoom(item.children, location + '/' + item.name)
            } else {
                room_locations[item.id] = location.slice(1) + '/' + item.name
            }
        })
    }
    await getOptionTree().then((data) => {
        getRoom(data ? data[0].children : [], '')
        room_list.value = room_locations
    })
}

// 状态列表
const statusList = [
    { name: '在线', value: 1 },
    { name: '离线', value: 0 }
]

// 左侧区域树
const faculty_tree = ref(null)
const current_node = ref({})
const handleNodeClick = (data) => {
    current_node.value = data
    resetQueryForm()
}

// 重置
const search_form = ref(null)
const resetQueryForm = () => {
    search_form.value.resetFields()
    getTableData()
}
// 数据源
const search_params = reactive({
    name: '',
    online: null,
    IMEI: '',
    ICCID: ''
})

const table_data = ref([])
const tableLoading = ref(true)
const total = ref(0)

// 获取列表数据
async function getTableData() {
    tableLoading.value = true
    const params = { ...search_params, ...page_params }
    if (current_node.value?.id) {
        if (current_node.value?.node_type !== undefined) {
            params.building = current_node.value.id
        } else {
            params.room = current_node.value.id
        }
    }
    params.type = 1
    getDeviceList(params).then((data) => {
        table_data.value = data.lists
        total.value = data.total
        tableLoading.value = false
    })
}

// 分页相关
const page_params = reactive({
    page: 1,
    page_size: 10
})
const handleSizeChange = (currentSize) => {
    page_params.page_size = currentSize
    page_params.page = 1
    getTableData()
}
const handleCurrentChange = (currentPage) => {
    page_params.page = currentPage
    getTableData()
}

// 表格多选
const selected_ids = ref([])
function handleSelectionChange(list) {
    selected_ids.value = list.map((item) => {
        return item.id
    })
}

const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const selectModelId = ref('') // 点中的模块id
const detail_data = ref({})
// 保证每次打开重新获取数据
watch(formDialogVisible, (val) => {
    if (!val) selectModelId.value = ''
})

// 查看
const onShowClick = (row) => {
    isForm.value = false
    selectModelId.value = row.id
    detail_data.value = row
    formDialogVisible.value = true
}
// 编辑
const onEditClick = (row) => {
    isForm.value = true
    selectModelId.value = row.id
    detail_data.value = row
    formDialogVisible.value = true
}
// 添加
const onAddClick = () => {
    ElMessageBox.prompt('请输入设备IMEI', {
        inputPattern: /^\d{15}$/,
        inputErrorMessage: '请输入15位数字',
        beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
                if (instance.inputValue) {
                    instance.confirmButtonLoading = true
                    addIMEI({
                        type: 1,
                        IMEI: instance.inputValue
                    })
                        .then(() => {
                            instance.confirmButtonLoading = false
                            ElMessage.success('添加成功')
                            getTableData()
                            done()
                        })
                        .catch(() => {
                            instance.confirmButtonLoading = false
                        })
                } else {
                    ElMessage.error('请输入设备IMEI')
                    instance.confirmButtonLoading = false
                }
            } else {
                done()
            }
        }
    })
}

// 删除
function onRemoveClick(ids) {
    ElMessageBox.confirm('是否确认删除选中的设备？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(() => {
        batchDeleteDevice({
            type: 1,
            id_list: ids
        }).then(() => {
            ElMessage.success('删除成功')
            getTableData()
        })
    })
}

// 导入
const uploadVisible = ref(false)
function importsComplete() {
    faculty_tree.value.getTreeData()
    getTableData()
}

// 导出
const handleExport = async () => {
    ElMessageBox.confirm('是否确认导出设备数据', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            const loading = ElLoading.service({
                lock: true,
                text: '正在导出...',
                spinner: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })

            let list = []
            await getDeviceList({
                type: 1,
                page: 1,
                page_size: total.value
            }).then((data) => {
                list = data.lists.map((item) => {
                    return {
                        location: item.room ? room_list.value[item.room].split('/') : [],
                        name: item.name,
                        IMEI: item.IMEI,
                        ICCID: item.ICCID
                    }
                })
            })
            if (list.length <= 0) {
                loading.close()
                return ElMessage.error('没有数据可导出')
            }

            // 创建excel并写入数据
            let workbook = null
            workbook = new Exceljs.Workbook()
            workbook.created = new Date()
            workbook.modified = new Date()
            workbook.lastPrinted = new Date()
            const worksheet = workbook.addWorksheet('设备', {
                properties: {
                    defaultRowHeight: 22
                },
                pageSetup: {
                    horizontalCentered: true
                }
            })

            worksheet.columns = [
                {
                    header: '小区',
                    key: 'community',
                    width: 30
                },
                {
                    header: '楼栋',
                    key: 'building',
                    width: 10
                },
                {
                    header: '单元',
                    key: 'unit',
                    width: 10
                },
                {
                    header: '楼层',
                    key: 'floor',
                    width: 10
                },
                {
                    header: '房间',
                    key: 'room',
                    width: 20
                },
                {
                    header: '户名',
                    key: 'name',
                    width: 20
                },
                {
                    header: 'IMEI',
                    key: 'IMEI',
                    width: 50
                },
                {
                    header: 'ICCID',
                    key: 'ICCID',
                    width: 50
                }
            ]

            worksheet.addRows(
                list.map((item) => {
                    return {
                        community: item.location[0] ?? '',
                        building: item.location[1] ?? '',
                        unit: item.location[2] ?? '',
                        floor: item.location[3] ?? '',
                        room: item.location[4] ?? '',
                        name: item.name,
                        IMEI: item.IMEI,
                        ICCID: item.ICCID
                    }
                })
            )

            worksheet.getRow(1).alignment = {
                horizontal: 'center',
                vertical: 'middle'
            }

            // 导出excel文件
            await workbook.xlsx.writeBuffer().then((buffer) => {
                const date = new Date()
                const year = date.getFullYear() // 年
                let month = date.getMonth() + 1 // 月
                let day = date.getDate() // 日
                let hour = date.getHours() // 时
                let minutes = date.getMinutes() // 分
                let seconds = date.getSeconds() // 秒
                // 给一位数的数据前面加 “0”
                if (month >= 1 && month <= 9) month = '0' + month
                if (day >= 0 && day <= 9) day = '0' + day
                if (hour >= 0 && hour <= 9) hour = '0' + hour
                if (minutes >= 0 && minutes <= 9) minutes = '0' + minutes
                if (seconds >= 0 && seconds <= 9) seconds = '0' + seconds
                const presentDate = `室温采集设备${year}${month}${day}${hour}${minutes}${seconds}`

                // 导出并存储文件
                FileSaver.saveAs(new Blob([buffer]), `${presentDate}.xlsx`)
            })
            loading.close()
        })
        .catch(() => {})
}

// 切换到前台时候执行
onMounted(() => {
    getModelList()
    getRoomTree()
    getTableData()
})
</script>

<style scoped></style>
